module.exports = __webpack_public_path__ + "static/media/george-icons.5f48bb36.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/george-icons.svg
// module id = 717
// module chunks = 21